var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"EC_width content"},[_c('p',{staticClass:"fontBold text_center marginTop40",staticStyle:{"font-size":"26px"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text_center marginTop40"}),_c('div',{staticClass:"border_bottom_18 marginBottom30"}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.details)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }